import React from 'react';
import NoteAddOutlinedIcon from '@material-ui/icons/NoteAddOutlined';
import Tooltip from "@material-ui/core/Tooltip";
import { Button } from 'wbm-inputs';

type AddNoteProps = {
    tooltipText: string,
    added: boolean,
    onClick: Function
}

export const AddNote = ({ ...props }: AddNoteProps) => {
    return (
        !props.added ?
            <Tooltip arrow placement="bottom" title={props.tooltipText} > 
                <Button className="btn-primary round" onClick={props.onClick}>
                    <NoteAddOutlinedIcon />
                </Button>
            </Tooltip>
            :
            <React.Fragment>
                <Button className="round add-note-added" onClick={props.onClick}>
                    <span className={"material-icons"}>
                        task               
                    </span>
                </Button>
            </React.Fragment>
    );
}
